import { useContext, useEffect, useState } from 'react';
import './NotificationList.scss';

import InfiniteScroll from 'react-infinite-scroll-component';
import {
  convertDateToRelativeDay,
  formatElapsedTime,
  formatIn12Hrs,
} from '../../utility/date.utils';
import { CoinsIcon } from '../../assets/Icon';
import NotificationContext from '../../contexts/NotificationContext';
import { Spinner } from 'react-bootstrap';

const NotificationList = () => {
  const { notificationData, loadMore, hasMore } =
    useContext(NotificationContext);

  const notificationsWithDate = () => {
    interface NotificationsByDate {
      [date: string]: (typeof notificationData)[0][];
    }

    const res = notificationData?.reduce(
      (notifications: NotificationsByDate, cv) => {
        const date = convertDateToRelativeDay(cv?.updatedAt);
        if (notifications[date]) {
          notifications[date] = [...notifications[date], cv];
        } else {
          notifications[date] = [cv];
        }
        return notifications;
      },
      {},
    );
    return res;
  };

  const handleLoadMore = () => {
    console.log(' >>>>>>> handleLoadMore');
    loadMore();
  };

  return (
    <div className="notification-content">
      <InfiniteScroll
        dataLength={notificationData?.length || 0}
        next={handleLoadMore}
        hasMore={hasMore}
        scrollableTarget="scrollableDiv-notifications"
        loader={
          <div className="d-flex justify-content-center align-items-center py-3">
            <Spinner animation="border" role="status" variant="primary">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        }
      >
        {Object.entries(notificationsWithDate()).length === 0 && (
          <>
            <div className="notificationContent-main">
              <div>
                <p className="mb-0 fw-bold">No new notifications</p>
              </div>
            </div>
          </>
        )}
        {Object.entries(notificationsWithDate()).length > 0 &&
          Object.entries(notificationsWithDate()).map(
            ([key, notificationArray], index) => {
              return (
                <div className="notificationContent-main" key={index}>
                  {/* <p className="notificationContent-key">{key}</p> */}
                  <div>
                    {notificationArray.length > 0 &&
                      notificationArray?.map((singleData, index) => {
                        return (
                          <div
                            className="singleData-main notificationContent-main"
                            key={index}
                          >
                            <div className="logo rounded-circle">
                              <CoinsIcon size={25} color={'var(--primary)'} />
                            </div>
                            <div>
                              <p className="mb-0 fw-bold">
                                {singleData?.title}
                              </p>
                              {/* @ts-ignore */}
                              <p className="mb-0">{singleData?.eventMessage}</p>
                            </div>
                            {/* @ts-ignore */}
                            <p>{formatElapsedTime(singleData?.createdAt)}</p>
                          </div>
                        );
                      })}
                  </div>
                </div>
              );
            },
          )}
      </InfiniteScroll>
    </div>
  );
};

export default NotificationList;
